import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import func from "@uikit/func";
import cls from "classnames";
import { Button, Input, Drawer, Space, message, Popover } from "antd";
import { editorActions } from "../../store/editor";
import { fotActions } from "../../store/fot";
import { Request, Response } from "./customAPIFunctionComponents";
import useObjectRelationGqlRequest from "../../custom-hooks/useObjectRelationGqlRequest";
import useCreateFunction from "../../custom-hooks/useCreateFunction";
import VariablePopoverContent from "./VariablePopoverContent";
import GuidanceContent from "./GuidanceContent";
import style from "./css/CustomAPIFunction.module.css";
import { eventbus } from "imagica-corekit/dist/base/cutil/Eventbus";
import { EdgeRunMsg } from "imagica-corekit/dist/base/msg/EdgeRunMsg";
import { defaultApis } from "@views/thinking-layout-editor/nodeTypeComponents/nodeTypeDispose";

function CustomAPIFunction(props) {
  const dispatch = useDispatch();
  const store = useStore();

  const { gql } = useObjectRelationGqlRequest();
  const { createFunction } = useCreateFunction();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [isModifyName, setIsModifyName] = useState(false);
  const [isDescription, setIsDescription] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const [responseData, setResponseData] = useState({});
  const [requestData, setRequestData] = useState({
    url: "",
    method: "get",
    headerList: [],
    bodyParam: "",
  });

  // const inputNameRef = useRef(null)
  // const inputDescriptionRef = useRef(null)

  const createAPIFuncData = useSelector(state => state.editor.createAPIFuncData);
  const setCreateAPIFuncData = val => {
    dispatch(editorActions.setCreateAPIFuncData(val));
  };
  const setCreateFunctionClick = val => {
    dispatch(fotActions.setCreateFunctionClick(val));
  };
  const setCommandEnterNodeId = val => {
    dispatch(fotActions.setCommandEnterNodeId(val));
  };

  // const clickName = () => {
  //   setIsModifyName(false)
  //   setTimeout(() => {
  //     if (util.isEmpty(inputNameRef.current)) return;
  //     inputNameRef.current?.focus()
  //   }, 100)
  // }
  // const clickDescription = () => {
  //   setIsDescription(false)
  //   setTimeout(() => {
  //     if (util.isEmpty(inputDescriptionRef.current)) return;
  //     inputDescriptionRef.current?.focus()
  //   }, 100)
  // }
  // const clickImport = () => {

  // }
  const onCancel = () => {
    setCreateAPIFuncData({
      open: false,
      loading: false,
      edgeId: "",
      sourceNodeId: "",
      targetNodeId: "",
      function: "",
      select: {},
      parameter: {},
    });

    setName("");
    setDescription("");
    setIsModifyName(false);
    setIsDescription(false);
    setRequestData({
      url: "",
      method: "get",
      headerList: [],
      bodyParam: "",
    });
    setResponseData({});
  };
  const handleOk = async () => {
    const newFunctionData = {
      description: createAPIFuncData?.parameter?.description || "",
      edgeArr: [],
      name: createAPIFuncData?.parameter?.name || "",
      nodeArr: [],
      type: "customApi",
      apiData: {
        requestData,
        // responseData
      },
    };
    const functionId = createAPIFuncData?.select?.id;
    try {
      setSaveLoading(true);
      if (!func.isEmpty(functionId)) {
        await gql.mutation.updateObject(functionId, {
          name: "studio_function",
          attributes: newFunctionData,
        });
      } else {
        const currentSingleFlow = props.singleFlowEdgeArrRef.current.find(x => x.name === newFunctionData.name);
        if (!func.isEmpty(currentSingleFlow)) {
          func.customMsg("Duplicate Name");
          setSaveLoading(false);
          return;
        }
        await createFunction(newFunctionData);
      }

      await props.requestSavedFunctionstList({
        tempOptions: defaultApis,
        isPagination: true,
      });
      const clickFuncData = {
        edgeId: createAPIFuncData.edgeId,
        functionName: newFunctionData.name,
      };
      setCreateFunctionClick(clickFuncData);
      setSaveLoading(false);
      func.customMsg({
        content: "Success",
        type: "success",
      });

      // 如果在首页则不继续执行
      if (props.showNavPage) return;
      // 给按钮下的文本赋值
      props.setEdgeLineParam({
        id: createAPIFuncData.edgeId,
        enterText: `/${newFunctionData.name}`,
      });
      // 显示run all按钮
      props.setQueryLoading(createAPIFuncData.edgeId, "isGetQuery", true);
      props.setQueryLoading(createAPIFuncData.edgeId, "isApiFunction", true);
      onCancel();
      // auto run
      setCommandEnterNodeId({
        nodeId: createAPIFuncData.sourceNodeId,
        targetNodeId: createAPIFuncData.targetNodeId,
        param: {
          selectValueParam: name,
          newAiDescription: `/${name}`,
        },
      });
      /// 设想通过发送EdgeRunMsg并在v3的edge中监听，以触发保存api func时自动run
      /// 但上面setCreateFunctionClick已经触发了edge run，所以这个代码不打开
      /// eventbus.emit(new EdgeRunMsg(createAPIFuncData.edgeId, false))
    } catch (error) {
      console.error("handleOk", error);
      setSaveLoading(false);
      func.messageError(error);
    } finally {
      setCreateAPIFuncData({ loading: false });
    }
  };
  useEffect(() => {
    if (func.isEmpty(createAPIFuncData.function)) return;
    const data = {
      onCancel: onCancel,
      handleOk: handleOk,
    };
    if (typeof data[createAPIFuncData.function] != "function") return;
    data[createAPIFuncData.function]();
    setCreateAPIFuncData({ function: "" });
  }, [createAPIFuncData.function]);
  useEffect(() => {
    if (func.isEmpty(createAPIFuncData.select)) return;
    // const currFuncData = props.singleFlowEdgeArrRef.current.find(x => x.name === createAPIFuncData.select.label)
    // copy function在imageGenSelectOptions中
    const imageGenSelectOptions = store.getState().fot.imageGenSelectOptions;
    const currFuncData = imageGenSelectOptions.find(x => x.label === createAPIFuncData.select.label);
    setName(currFuncData.label);
    setDescription(currFuncData.description);

    setRequestData(currFuncData.apiData.requestData);
    // setResponseData(currFuncData.apiData.responseData)
  }, [createAPIFuncData.select]);

  return (
    <Drawer
      className={cls(style["customAPIFunction-box"], createAPIFuncData.open && style["occlusion"])}
      // title={
      //   <>
      //     <Input
      //       value={name}
      //       // ref={inputNameRef}
      //       bordered={!isModifyName}
      //       className={style['input-box']}
      //       onChange={(e) => setName(e.target.value)}
      //       placeholder="Enter function name"
      //       onFocus={() => setIsModifyName(false)}
      //       onBlur={() => setIsModifyName(true)}
      //       onPressEnter={() => setIsModifyName(true)}
      //     />
      //     <Input
      //       value={description}
      //       // ref={inputDescriptionRef}
      //       bordered={!isDescription}
      //       className={style['input-box']}
      //       onChange={(e) => setDescription(e.target.value)}
      //       placeholder="Enter function description"
      //       onFocus={() => setIsDescription(false)}
      //       onBlur={() => setIsDescription(true)}
      //       onPressEnter={() => setIsDescription(true)}
      //     />
      //   </>
      // }
      placement="bottom"
      open={createAPIFuncData.open}
      closable={false}
      // extra={
      //     <Space>
      //       {/* <Button type="primary" onClick={clickImport}>Import</Button> */}
      //       <Button onClick={onCancel}>Cancel</Button>
      //       <Button
      //         type="primary"
      //         loading={saveLoading}
      //         disabled={util.isEmpty(name)}
      //         onClick={handleOk}
      //       >
      //         Save
      //       </Button>
      //     </Space>
      //   }
    >
      <div className={style["content-box"]}>
        {/* 请求区域 */}
        <Request
          requestData={requestData}
          setRequestData={setRequestData}
          sendLoading={sendLoading}
          sendRequest={props.sendRequest}
          evaluateFinalBodyStr={props.evaluateFinalBodyStr}
          setSendLoading={setSendLoading}
          setResponseData={setResponseData}
        />
        {/* 响应区域 */}
        <Response responseData={responseData} />
        {/* 底部工具栏 */}
        <div className={style["tool-bar-box"]}>
          <div className={style["bottom-tool-bar"]}>
            <Popover content={<VariablePopoverContent showDelet={false} />}>
              <span className="iconfont icon-bianliang"></span>
            </Popover>

            {/* Custom JS function guidance */}
            {
              <Popover content={<GuidanceContent type="customApiFunction" />}>
                <span className="iconfont icon-i-info"></span>
              </Popover>
            }
          </div>
        </div>
      </div>
    </Drawer>
  );
}

export default CustomAPIFunction;
